module.exports = __webpack_public_path__ + "img/bank.a2bc707d.svg";